import isPropValid from '@emotion/is-prop-valid'
import { media } from '@hg/stylizator/utils'
import * as React from 'react'
import styled from 'styled-components'

interface IProps {
  leftButton?: React.ReactNode
  rightButton?: React.ReactNode
}

const Buttons: React.FC<React.PropsWithChildren<IProps>> = (props) => {
  const buttonCount = [props.leftButton, props.rightButton].filter((val) => val != null).length

  return (
    <ButtonsView buttonCount={buttonCount}>
      {props.leftButton}
      {props.rightButton}
    </ButtonsView>
  )
}

const ButtonsView = styled.div.withConfig({ shouldForwardProp: isPropValid })<{ buttonCount: number }>`
  display: flex;
  gap: 24px;

  @media ${media.tablet}, ${media.mobile} {
    gap: 8px;
    width: 100%;
    flex-direction: column;
    justify-content: ${(props) => (props.buttonCount === 2 ? 'space-between' : 'center')};
  }
`

export default Buttons
